import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
}
  body {
    margin: 0;
    padding: 0;
    font-family: proxima-nova, sans-serif;
  }
`;

export default GlobalStyle;
